// @flow
import UserProfile from 'common/modules/userProfile/domain/UserProfile';
import {
  FETCH_PROFILE,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_EMAIL,
  UPDATE_EMAIL_SUCCESS,
  UPDATE_EMAIL_FAILURE,
  CONFIRM_EMAIL,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_FAILURE,
} from '../actions/userProfileActions';

export type UserProfileState = {
  userEmail: string,
  userProfile?: UserProfile,
  error: boolean,
  isFetched: boolean,
  updating: boolean,
  confirmEmailError: boolean,
  editEmailError: any,
  editPasswordError: boolean,
};

export const INITIAL_STATE: UserProfileState = {
  userProfile: undefined,
  userEmail: '',
  error: false,
  isFetched: false,
  updating: false,
  editEmailError: {},
  editPasswordError: false,
  confirmEmailError: false,
};

export default (state: UserProfileState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case FETCH_PROFILE:
      return {
        ...state,
        error: false,
        isFetched: false,
      };
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.userProfile,
        userEmail: action.userEmail,
        isFetched: true,
      };
    case FETCH_PROFILE_FAILURE:
      return {
        ...state,
        error: true,
        isFetched: true,
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        error: false,
        updating: true,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.userProfile,
        updating: false,
      };
    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        error: true,
        updating: false,
      };
    case UPDATE_PASSWORD:
      return {
        ...state,
        editPasswordError: false,
        updating: true,
      };
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        fetching: false,
        editPasswordError: false,
        updating: false,
      };
    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        fetching: false,
        editPasswordError: true,
        updating: false,
      };
    case UPDATE_EMAIL:
      return {
        ...state,
        error: false,
        updating: true,
        editEmailError: false,
      };
    case UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        updating: false,
        editEmailError: false,
      };
    case UPDATE_EMAIL_FAILURE:
      return {
        ...state,
        error: true,
        updating: false,
        editEmailError: action.error,
      };
    case CONFIRM_EMAIL:
      return {
        ...state,
        error: false,
        updating: true,
        confirmEmailError: false,
      };
    case CONFIRM_EMAIL_SUCCESS:
      return {
        ...state,
        updating: false,
        confirmEmailError: false,
      };
    case CONFIRM_EMAIL_FAILURE:
      return {
        ...state,
        updating: false,
        confirmEmailError: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/userProfile/reducers/userProfileReducer.js